module.exports = __webpack_public_path__ + "static/img/right-top-pendant.e6d5213.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/right-top-pendant.png
// module id = 7Ic8
// module chunks = 1